import {
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
} from '@chakra-ui/react';
import ROUTER from '@constants/router';
import usePopup from '@hooks/usePopup';
import { signOut, useSession } from 'next-auth/react';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import { FaHistory } from 'react-icons/fa';
import { HiOutlineHome } from 'react-icons/hi';
import { LuLogOut } from 'react-icons/lu';
import { RiRefund2Fill } from 'react-icons/ri';
import NavProfile from '../components/nav-profile';
import NavSignButton from '../components/nav-sign-button';
import LanguageMenu from './language-menu';

export default function NavMenuDrawer() {
  const { closeAllPopup } = usePopup();
  const { status } = useSession();
  const { t } = useTranslation();

  return (
    <DrawerContent>
      <DrawerCloseButton color="white" fontWeight="bold" fontSize="large" />
      <DrawerHeader h="30vh" minH="30vh" className="bg-primary-500 text-white">
        {status === 'authenticated' ? <NavProfile /> : <NavSignButton />}
      </DrawerHeader>
      <DrawerBody>
        <div className="pt-[18px] flex flex-col justify-between h-full">
          <div>
            <ul className="flex flex-col gap-[8px] [&>li>a>p]:flex [&>li>a>p]:gap-[6px] [&>li>a>p]:font-bold [&>li>a>p]:text-[18px]">
              <li>
                <Link href="/" onClick={closeAllPopup}>
                  <p className="flex gap-[6px] items-center">
                    <HiOutlineHome />
                    {t('home:home')}
                  </p>
                </Link>
              </li>
              <li>
                <Link href={ROUTER.order} onClick={closeAllPopup}>
                  <p className="flex gap-[6px] items-center">
                    <FaHistory />
                    {t('home:order_histories')}
                  </p>
                </Link>
              </li>
              <li>
                <Link href="/refund" onClick={closeAllPopup}>
                  <p className="flex gap-[6px] items-center">
                    <RiRefund2Fill />
                    {t('home:refund_page')}
                  </p>
                </Link>
              </li>
              <li>
                <LanguageMenu />
              </li>
            </ul>
          </div>
          <div>
            <button
              className="flex items-center gap-[6px]"
              onClick={() => signOut({ redirect: true, callbackUrl: '/' })}
            >
              <LuLogOut />
              <span>{t('home:logout_button')}</span>
            </button>
          </div>
        </div>
      </DrawerBody>
    </DrawerContent>
  );
}
